var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import { shape, string, func } from 'prop-types';
import blocks from './list';
import { emptyFunc } from 'searchband-frontend-commons/util/func';
import * as CLS from '../cls';

var Block = function (_PureComponent) {
    _inherits(Block, _PureComponent);

    function Block() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Block);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Block.__proto__ || Object.getPrototypeOf(Block)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
            var _this$props = _this.props,
                onAction = _this$props.onAction,
                block = _this$props.block;


            event.stopPropagation();
            onAction(block.action);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Block, [{
        key: 'render',
        value: function render() {
            var props = this.props;
            var block = props.block;


            if (!block) {
                return null;
            }

            var Component = blocks[block.type];

            if (!Component) {
                return null;
            }

            return React.createElement(Component, _extends({
                marginLeft: props.marginLeft,
                marginRight: props.marginRight,
                baseClass: CLS.block(props.block.paddingModifier)()
            }, block, {
                onAction: props.onAction,
                onClick: block.action ? this.handleClick : null,
                onContentUpdated: props.onContentUpdated
            }));
        }
    }]);

    return Block;
}(PureComponent);

Block.defaultProps = {
    block: null,
    onAction: emptyFunc,
    onContentUpdated: emptyFunc
};
Block.propTypes = {
    block: shape({
        type: string.isRequired
    }).isRequired,
    onAction: func.isRequired,
    onContentUpdated: func
};
export default Block;